import { render, staticRenderFns } from "./Answers.vue?vue&type=template&id=765aaaca&scoped=true&"
import script from "./answers.js?vue&type=script&lang=js&"
export * from "./answers.js?vue&type=script&lang=js&"
import style0 from "./answers.scss?vue&type=style&index=0&id=765aaaca&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "765aaaca",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("n:\\Data\\Projects\\Werk\\DPG\\DNX2-DPG\\MarketingDb.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('765aaaca')) {
      api.createRecord('765aaaca', component.options)
    } else {
      api.reload('765aaaca', component.options)
    }
    module.hot.accept("./Answers.vue?vue&type=template&id=765aaaca&scoped=true&", function () {
      api.rerender('765aaaca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ScriptsV2/Core/Modules/AudienceManager/Components/Builder/OverviewTab/Answers.vue"
export default component.exports